var _defs, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dashboard_icon",
    "data-name": "dashboard icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M0,20A20,20,0,1,1,20,40,20,20,0,0,1,0,20Z",
    fill: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask-2",
    "data-name": "Mask",
    d: "M0,0H24V24H0V0Z",
    transform: "translate(8 8)",
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Mask-3",
    "data-name": "Mask",
    d: "M0,20A20,20,0,1,1,20,40,20,20,0,0,1,0,20Z",
    fill: "#F6F6F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashboard_icon-2",
    "data-name": "dashboard icon",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_path",
    "data-name": "Shape path",
    d: "M1,10H7A1,1,0,0,0,8,9V1A1,1,0,0,0,7,0H1A1,1,0,0,0,0,1V9a1,1,0,0,0,1,1Z",
    transform: "translate(11 11)",
    fill: "#0270B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_path-2",
    "data-name": "Shape path",
    d: "M1,6H7A1,1,0,0,0,8,5V1A1,1,0,0,0,7,0H1A1,1,0,0,0,0,1V5A1,1,0,0,0,1,6Z",
    transform: "translate(11 23)",
    fill: "#0270B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_path-3",
    "data-name": "Shape path",
    d: "M1,10H7A1,1,0,0,0,8,9V1A1,1,0,0,0,7,0H1A1,1,0,0,0,0,1V9a1,1,0,0,0,1,1Z",
    transform: "translate(21 19)",
    fill: "#0270B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_path-4",
    "data-name": "Shape path",
    d: "M0,1V5A1,1,0,0,0,1,6H7A1,1,0,0,0,8,5V1A1,1,0,0,0,7,0H1A1,1,0,0,0,0,1Z",
    transform: "translate(21 11)",
    fill: "#44A6E0"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Mask-4",
    "data-name": "Mask",
    d: "M0,0H24V24H0V0Z",
    transform: "translate(8 8)",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.51c4d2107322d5e8d4e220df857ad5d3.svg";
export { ForwardRef as ReactComponent };